const getLocation = agenda => {
  const data = {
    id: agenda.location.id,
    distance: agenda.location.distance
  }

  if (agenda.location.id === 'current') {
    data['latitude'] = agenda.location.latitude
    data['longitude'] = agenda.location.longitude
  }

  if (agenda.location.id === 'add') {
    data['address'] = agenda.address
  }

  if (agenda.location.id === 'all') {
    data['latitude'] = agenda.location.latitude
    data['longitude'] = agenda.location.longitude
  }

  return data
}

export default (searchedBy, filters, agenda) => {
  filters['location'] = getLocation(agenda)
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/filters/filterByLocation.js